import fetchCategories from 'src/api/fetch-categories';


const SET_CATEGORIES = 'SET_CATEGORIES';

const setCategories = categories => ({
  type: SET_CATEGORIES,
  payload: {
    categories
  }
});

const getCategories = () => (dispatch, getState, { http }) => fetchCategories({
  http
})
  .then((categories) => {
    dispatch(setCategories(categories));
    return categories;
  })
  .catch((error) => {
    throw new Error(`Error during fetchCategories: ${error}`);
  });

export {
  SET_CATEGORIES,
  setCategories,
  getCategories
};
